<template>
  <div>
    <!-- <h1>订单列表</h1> -->
    <el-table :data="pagedData" style="width: 100%">
      <!-- <el-table-column prop="id" label="ID" width="180"></el-table-column> -->
      <el-table-column
        prop="orderNo"
        label="订单号"
        width="230"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="weixinOrderNo"
        label="微信订单号"
        width="210"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="orderAmountStr"
        label="订单金额"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="orderStatusStr"
        label="订单状态"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="tradeTypeStr"
        label="支付类型"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="payChannel"
        label="支付渠道"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="用户名"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="paySuccessTimeStr"
        label="支付时间"
        width="200"
        align="center"
      ></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getOrderPage } from '@/api/pay'

export default {
  data () {
    return {
      pagedData: [],
      allData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    async fetchData (page = 1, size = 10) {
      const result = await getOrderPage(page, size)
      console.log(result)

      const { records, total, current } = result.data
      this.pagedData = records
      this.total = +total
      this.pageSize = +result.data.size
      this.currentPage = +current
    },
    handleSizeChange (newSize) {
      this.pageSize = newSize
      this.fetchData(this.currentPage, this.pageSize)
    },
    handleCurrentChange (newPage) {
      this.currentPage = newPage
      this.fetchData(this.currentPage, this.pageSize)
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style lang="less" scoped>
/* 你可以在这里添加样式 */
h1 {
  font-size: 24px;
  margin: 10px 0 10px 10px;
}

.el-table {
  margin: 10px 0 10px 20px;
}

.el-pagination {
  text-align: center;
}

/* 移动端适配 - 不影响PC端 */
@media screen and (max-width: 768px) {
  .el-table {
    margin: 10px 0;
    font-size: 12px;
    overflow-x: auto;
    display: block;
    white-space: nowrap;
  }

  .el-pagination {
    font-size: 12px;
    padding: 10px 0;
  }
}
</style>
